import { connectRealtimeWhenAvailable } from '@beatq/shared';

export type MintedBusinessRealtimeTicket = {
  ticket: string;
  websocketUrl?: string;
};

export type BusinessOpsSocket = NonNullable<
  Awaited<ReturnType<typeof connectRealtimeWhenAvailable>>
>;

/** Slow REST fallback while the Socket.IO room is connected. */
export const BUSINESS_LIVE_FALLBACK_POLL_MS = 60_000;

export function businessOpsPollMs(live: boolean, downMs: number): number {
  return live ? BUSINESS_LIVE_FALLBACK_POLL_MS : downMs;
}

/** Parse BE mint envelope: `{ data: { connection: { ticket, websocketUrl } } }`. */
export function parseBusinessRealtimeTicketEnvelope(
  envelope: unknown,
): MintedBusinessRealtimeTicket | null {
  if (envelope == null || typeof envelope !== 'object') return null;
  const root = envelope as Record<string, unknown>;
  const data =
    root.data && typeof root.data === 'object' ? (root.data as Record<string, unknown>) : root;
  const connection =
    data.connection && typeof data.connection === 'object'
      ? (data.connection as Record<string, unknown>)
      : data;
  const ticket =
    (typeof connection.ticket === 'string' && connection.ticket) ||
    (typeof connection.token === 'string' && connection.token) ||
    null;
  if (!ticket) return null;
  const websocketUrl =
    (typeof connection.websocketUrl === 'string' && connection.websocketUrl) ||
    (typeof connection.url === 'string' && connection.url) ||
    undefined;
  return { ticket, websocketUrl };
}

export function bindBusinessSocketLive(
  socket: BusinessOpsSocket,
  onLive: (live: boolean) => void,
): () => void {
  const sync = () => onLive(Boolean(socket.connected));
  socket.on('connect', sync);
  socket.on('disconnect', sync);
  sync();
  return () => {
    socket.off('connect', sync);
    socket.off('disconnect', sync);
  };
}
